import styles from './TotpCodeField.module.css'

interface TotpCodeFieldProps {
  id: string
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  label?: string
  autoFocus?: boolean
}

export function TotpCodeField({
  id,
  value,
  onChange,
  disabled = false,
  label = 'Código do autenticador',
  autoFocus = false,
}: TotpCodeFieldProps) {
  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <input
        id={id}
        className={styles.input}
        inputMode="numeric"
        autoComplete="one-time-code"
        pattern="[0-9]*"
        maxLength={6}
        placeholder="000000"
        value={value}
        autoFocus={autoFocus}
        disabled={disabled}
        onChange={(event) => {
          onChange(event.target.value.replace(/\D/g, '').slice(0, 6))
        }}
      />
    </div>
  )
}
